// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--2w4nY","description":"styles-module--description--3NQqf"};